import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductSettingsDTO } from '@modeso/types__dgoods-products';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as ProductSettingsActions from '../actions/products.actions';
import { ProductsService } from '../service/products.service';

@Injectable()
export class ProductSettingsEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly productsService: ProductsService,
    ) {}

    getProductSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProductSettingsActions.getProductsSettings),
            mergeMap(() =>
                this.productsService.getProductsSettings().pipe(
                    map((productsSettings: ProductSettingsDTO[]) =>
                        ProductSettingsActions.getProductsSettingsSuccess({ productsSettings }),
                    ),
                    catchError((error: HttpErrorResponse) =>
                        of(ProductSettingsActions.getProductsSettingsFailure({ error })),
                    ),
                ),
            ),
        ),
    );

    updateProductSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProductSettingsActions.updateProductSettings),
            mergeMap((action) =>
                this.productsService.updateProductSettings(action.productsSettings).pipe(
                    map((productsSettings: ProductSettingsDTO) =>
                        ProductSettingsActions.updateProductSettingsSuccess({ productsSettings }),
                    ),
                    catchError((error: HttpErrorResponse) =>
                        of(ProductSettingsActions.updateProductSettingsFailure({ error })),
                    ),
                ),
            ),
        ),
    );
}
